import React from "react";
import { FaUserCircle } from "react-icons/fa";

const Testismonial = () => {
  return (
    <div className="py-[64px] flex flex-col justify-center items-center px-6 border-zinc-400/10">
      <h3 className="text-zinc-100 text-center text-bold text-2xl font-bold uppercase">
        Testismonial
      </h3>
      <p className="text-italics text-zinc-400 text-center mb-6">
        We have worked with amazing people
      </p>
      <div className="max-w-xl grid place-content-center place-items-center">
        <figure className="rounded-xl bg-black p-4 shadow-sm">
          <blockquote className="text-white">
            <p>
              "I will do business again an again with Taofeek. I love the fact
              that he is patient enough to implement all the scope of the
              designs and work I requested and the changes required. I do
              recommend his services."
            </p>
          </blockquote>
          <figcaption className="mt-5 flex items-center gap-4">
            <FaUserCircle className="w-10 h-10 rounded-full" />
            <div>
              <h6 className="font-semibold text-white/80">
                Emmanuel Esanoluwa
              </h6>
              <p className="text-white/50">@emmanuelesanoluwa</p>
            </div>
          </figcaption>
        </figure>
      </div>
    </div>
  );
};

export default Testismonial;
